import React from 'react';

const DeleteModal = ({ message, onConfirm, onCancel, handleCloseModal }) => {

  // const handleOverlayClick = (e) => {
  //   if (e.target === e.currentTarget) {
  //     onCancel();
  //   }
  // };

  const cancelButton = () => {
    onCancel()
    
  }

  return (
    <div className="customer-vehicle-info__modal-overlay" >
      <div className="customer-vehicle-info__confirmation-modal">
        {/* <div className="customer-vehicle-info__confirmation-header">
          <h3 className="customer-vehicle-info__confirmation-title" style={{fontFamily: "Karbon-medium"}}>Confirm Delete</h3>
        </div> */}
        
        <div className="customer-vehicle-info__confirmation-content">
          <p className="customer-vehicle-info__confirmation-message" style={{fontFamily: "Karbon-regular", fontSize: "16px", padding: "10px 0"}}>{message}</p>
        </div>
        
        <div className="customer-vehicle-info__confirmation-footer">
          <button 
            className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--delete-confirm"
            style={{borderRadius: "20px", background: "#ff6b35", color: "white"}}
            onClick={onConfirm}
          >
            Delete
          </button>
          <button 
            className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--cancel"
            onClick={cancelButton}
            style={{borderRadius:"20px"}}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;